import { useTranslation } from 'react-i18next';
import ServicesCard from '../../AppointmentBooking/ChooseServices/ServicesCard';
import s from './ChooseServices.module.scss'; 
import Button from 'components/shared/Button';

const ChooseServices = ({
  services,
  selectedIds,
  handleChoose,
  handleNext,
  setDuration,
  setPrice,
  setSelectedServiceHistory,
  setBookingItemsWithDiscount
}: any) => {
  const handleChooseService = item => {
    const isServiceAlreadySelected = selectedIds?.includes(item?.service);

    const selectedServices = isServiceAlreadySelected
      ? selectedIds?.filter(el => el !== item?.service)
      : [...selectedIds, item?.service];
    handleChoose(selectedServices);
    setSelectedServiceHistory(selectedServices);
    setDuration(item?.duration);

    const selectedServicesDetails = services.filter(service =>
      selectedServices.includes(service?.service),
    );

    const totalDuration = selectedServicesDetails.reduce(
      (sum, service) => sum + (service?.duration || 0),
      0,
    );
    const totalPrice = selectedServicesDetails.reduce(
      (sum, service) => sum + (service?.price || 0),
      0,
    );

    // setDuration(totalDuration)
    setPrice(totalPrice);
    setBookingItemsWithDiscount((prev) => {
      return [
        ...prev,
        {
          service: item?.service,
          price: item?.price
        }
      ]
    })
  };
      const {t} = useTranslation() as any
  return (
    <div className={s.choose_services}>
      <div className={s.choose_services_title}>Choose services</div>
      <div className={s.choose_services_cards}>
             {services?.length === 0 && <div>{t("No services")}</div>}
        {services?.map(item => {
          return (
            <div key={item.id} onClick={() => handleChooseService(item)}>
              <ServicesCard
                title={item?.services?.name}
                duration={item?.duration}
                price={item?.price}
                isSelected={selectedIds?.includes(item?.service)}
              />
            </div>
          );
        })}
      </div>
      <div>
        <Button
          className={s.choose_services_button}
          wide
          darkGreen
          disabled={!selectedIds?.length}
          onClick={handleNext}
        >
          Book now
        </Button>
      </div>
    </div>
  );
};

export default ChooseServices;
